import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BarChartComponent } from '../../../my-shared-lib/src/lib/chart-components/bar-chart/bar-chart.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { ChatComponent } from '../../../my-shared-lib/src/lib/global-components/chat/chat.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'price-file-simulation',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {
    path: 'opportunity-simulator',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { dvmWorkflowAppId: 'opportunity-simulator-config.json' },
  },
  {
    path: 'opportunity-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { dvmWorkflowAppId: 'opportunity-overview-config.json' },
  },
  {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { dvmWorkflowAppId: 'europe-Impact-report.json' },
  },
  {
    path: 'sales-overview',
    component: BarChartComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'customer-overview',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'customer-overview.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-bridge',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'cspec-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-sales-bridge',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'cspec-sales-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'simulation',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'simulation-config.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'price-file-simulation',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'price-file-simulation.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'price-file-simulation/detail',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'price-file-simulation-detail.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'price-file-simulation/deep-dive',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'price-file-simulation-deep-dive.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'test',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'test.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'price-file-simulation/new',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'price-file-simulation-new.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'chat',
    component: ChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'price-file-simulation',
  },
];
